import request from "@/utils/request";

const market = {

	getProductList: (data) => {
		return request({
			url: 'app_markets/getProductList',
			method: 'GET',
			data
		})
	},
	getAppList: (data) => {
		return request({
			url: '/Apps/getAppList',
			method: 'GET',
			data
		})
	},
	create: (data) => {
		return request({
			url: 'Apps/create',
			method: 'POST',
			data
		})
	},
	launchProduct: (data) => {
		return request({
			url: 'Apps/launchProduct',
			method: 'POST',
			data
		})
	},
	deleteApp: (data) => {
		return request({
			url: 'Apps/delete',
			method: 'DELETE',
			data
		})
	},
	qiniuSetting: (data) => {
		return request({
			url: 'Apps/qiniuSetting',
			method: 'POST',
			data
		})
	},


}
export default market;